import styled from "styled-components";
import colours from "../../lib/colours";

const TextButton = styled.button`
  display: flex;
  justify-content: center;
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-family: vic;
  font-weight: 400;
  padding-inline: 0;
  &:focus {
    outline: none;
  }
  &:hover {
    color: ${colours.th1l2};
  }
  color: ${colours.th1};
  transition: color 0.35s ease;
`;

export const TextButtonPrimary = styled(TextButton)`
  color: ${colours.th2d1};
  &:hover {
    color: ${colours.th2};
  }
`;

export default TextButton;
